import { createFileRoute } from "@tanstack/react-router";
import UploadPresetPage from "src/components/app/UploadPresetPage/UploadPresetPage";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { projectLoader } from "src/lib/ScopedLoaders";
import { getUploadPresetsPageData } from "src/server/functions/Portal";

export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/upload-presets")({
  loader: projectLoader((projectId) => getUploadPresetsPageData({ data: projectId })),
  component: UploadPresetsPage,
});

function UploadPresetsPage() {
  return (
    <DeferredLoaderData result={Route.useLoaderData()}>
      {(data) => <UploadPresetPage initialPage={data?.initialPage} folders={data?.folders} />}
    </DeferredLoaderData>
  );
}
